/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import PageHeader from '@atlaskit/page-header';
import { Sale } from './types';
import { useHref } from 'react-router';
import { useIntl } from 'components/i18n';

type Props = {
  sale: Sale | null;
  isRecurring: boolean;
  isNew: boolean;
}

const SaleEditHeader: React.FC<Props> = ({sale, isRecurring, isNew}) => {

  const salesHref = useHref('../../');
  const saleViewHref = useHref('../');
  const recurringSalesHref = useHref('../../');
  const recurringSaleViewHref = useHref('../');

  const intl = useIntl();

  if(!sale) { return null}

  let path = intl.formatMessage({
    id: 'sale.SaleEditHeader.recurringInvoices.path',
    defaultMessage: 'Recurring invoices',
  });

  let titleNew = intl.formatMessage({
    id: 'sale.SaleEditHeader.recurringInvoices.title.new',
    defaultMessage: 'New recurring invoice',
  });

  let titleEdit = intl.formatMessage({
    id: 'sale.SaleEditHeader.recurringInvoices.title.edit',
    defaultMessage: 'Edit recurring invoice',
  });

  if(isRecurring) {
    return (<PageHeader
      breadcrumbs={
        <Breadcrumbs onExpand={() => {}}>
          <BreadcrumbsItem text={path} key={path} href={recurringSalesHref}/>
          <BreadcrumbsItem
            href={recurringSaleViewHref}
            text={sale?.invoiceNumber || ''}
            key={sale?.invoiceNumber || ''}
          />
        </Breadcrumbs>
      }
    >
      {isNew? titleNew : titleEdit}
    </PageHeader>);
  }

  path = intl.formatMessage({
    id: 'sale.SaleEditHeader.invoices.path',
    defaultMessage: 'Invoices',
  });

  titleNew = intl.formatMessage({
    id: 'sale.SaleEditHeader.invoices.title.new',
    defaultMessage: 'New sale invoice',
  });

  titleEdit = intl.formatMessage({
    id: 'sale.SaleEditHeader.invoices.title.edit',
    defaultMessage: 'Edit invoice {invoiceNumber}',
  }, {invoiceNumber: sale.invoiceNumber});

  return (
    <PageHeader
  breadcrumbs={
  <Breadcrumbs onExpand={() => {}}>
    <BreadcrumbsItem text={path} key={path} href={salesHref}/>
    <BreadcrumbsItem
      href={saleViewHref}
      text={sale?.invoiceNumber || ''}
      key={sale?.invoiceNumber || ''}
    />
  </Breadcrumbs>
}
>
  {isNew? titleNew : titleEdit}
</PageHeader>);
};

export default SaleEditHeader;
